import CssBaseline from '@mui/material/CssBaseline';
import React, { useCallback } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AuthView } from 'views/Auth/Auth.view';
import { PanelView } from 'views/Panel/Panel.view';
import { ROUTE_AUTH, ROUTE_PANEL, ROUTE_QUESTIONNAIRES, ROUTE_ROOT } from 'config/routes';
import { QuestionnairesView } from 'views/Questionnaires/Questionnaires.view';
import { NotFoundView } from './Errors/NotFound.view';
import { postPersonalDataAccessPrintout } from 'store/reports/reports.action';
import { getFromUrl } from 'utils/personalDataAccessRegister/personalDataAccessRegister';

export const MainView: React.FC = () => {
  const dispatch: (...params: any) => Promise<any> = useDispatch();

  const handlePersonalDataAccess = useCallback(() => {
    return dispatch(
      postPersonalDataAccessPrintout({
        url: getFromUrl(),
      }),
    );
  }, [dispatch]);

  window.addEventListener('afterprint', () => {
    handlePersonalDataAccess();
  });

  return (
    <>
      <CssBaseline />
      <Routes>
        <Route path={ROUTE_ROOT} element={<Navigate to={ROUTE_PANEL} replace />} />
        <Route path={`${ROUTE_QUESTIONNAIRES}/*`} element={<QuestionnairesView />} />
        <Route path={`${ROUTE_PANEL}/*`} element={<PanelView />} />
        <Route path={`${ROUTE_AUTH}/*`} element={<AuthView />} />
        <Route path="*" element={<NotFoundView />} />
      </Routes>
    </>
  );
};
